import { useEffect, useRef, useState } from "react";

const Message = ({ message, onClose, type }) => {
  const [visible, setVisible] = useState(false);
  const [closing, setClosing] = useState(false);
  const onCloseRef = useRef(onClose);

  const duration = 3000;

  const styles = {
    success: "bg-green-50/80 border-green-300 text-green-800",
    error: "bg-red-200 border-red-800 text-red-800",
    warning: "bg-yellow-50/80 border-yellow-300 text-yellow-800",
    info: "bg-blue-50/80 border-blue-300 text-blue-800",
  };

  useEffect(() => {
    onCloseRef.current = onClose;
  }, [onClose]);

  useEffect(() => {
    const showTimer = setTimeout(() => setVisible(true), 10);
    const closeTimer = setTimeout(() => setClosing(true), duration);
    const removeTimer = setTimeout(() => onCloseRef.current?.(), duration + 300);

    return () => {
      clearTimeout(showTimer);
      clearTimeout(closeTimer);
      clearTimeout(removeTimer);
    };
  }, []);

  return (
    <div
      className={`
        pointer-events-auto
        min-w-[260px] max-w-sm px-4 py-3 rounded-lg border shadow-md backdrop-blur-sm
        transition-all duration-300 ease-in-out
        ${styles[type] || styles.info}
        ${visible && !closing
          ? "opacity-100 translate-y-0"
          : "opacity-0 -translate-y-2"}
      `}
    >
      <div className="flex items-center justify-between gap-3">
        <p className="text-sm font-medium">{message}</p>

        <button
          onClick={() => {
            setClosing(true);
            setTimeout(() => onCloseRef.current?.(), 300);
          }}
          className="font-bold opacity-70 hover:opacity-100"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default Message;